import { useState, useEffect } from 'react'
import { Layout, Button, Menu } from 'antd'
import { Link } from "react-router-dom"
import { LeftOutlined } from '@ant-design/icons'
import Feather from '@sysunite/react-feather'
import AclRouter from './AclRouter'
{ Header, Sider } = Layout

MenuIcon = ({ type }) ->
  <Feather
    type={type}
    size={18}
    style={{ marginRight: 10, top: 2, position: 'relative' }}
  />

views = [{
  title: "Domains"
  route: "domains"
  icon: "globe"
}, {
  title: "All spaces"
  route: "spaces"
  icon: "database"
}, {
  title: "All users"
  route: "users"
  icon: "user"
}, {
  title: "User groups"
  route: "roles"
  icon: "users"
}, {
  title: "Organisations"
  route: "organisations"
  icon: "globe"
}, {
  title: "Global permissions"
  route: "permissions"
  icon: "key"
}]

Views = ({ history, match }) ->
  [active, setActive] = useState(undefined)

  useEffect(->
    setActive(location.pathname.split('/').find((path) ->
      views.find((view) ->
        view.route is path
      )
    ))
  , [match])

  <Layout>
    <AclRouter />
  </Layout>

export default Views
